export default __webpack_public_path__ + "static/media/blue-logo.fd4b5e45.svg";